import { createSlice } from "@reduxjs/toolkit";

export const SetApplicationTitle = createSlice({
  name: "applicationTitle",
  initialState: {
    applicationTitle: "global.documentTitle",
  },

  reducers: {
    applicationTitle: (state, action) => {
      state.applicationTitle = action.payload;
    },
  },
});

export const { applicationTitle } = SetApplicationTitle.actions;

export default SetApplicationTitle.reducer;
